import { LoadableAfterPaint } from '@confluence/loadable';

export const SmartCreateFeedbackBannerLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartCreateFeedbackBanner" */ './SmartCreateFeedbackBanner.tsx'
			)
		).SmartCreateFeedbackBanner,
});
